import { render } from "./ShortcutOverview.vue?vue&type=template&id=7ba63103&scoped=true"
import script from "./ShortcutOverview.vue?vue&type=script&lang=js"
export * from "./ShortcutOverview.vue?vue&type=script&lang=js"

import "./ShortcutOverview.vue?vue&type=style&index=0&id=7ba63103&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba63103"]])

export default __exports__